<template>
  <div
    :class="[
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: stateStoreInstance.open, 'attendants-day-sidebar': isScheduleActive },
    ]"
    id="sidebar-area"
  >
  <div class="sidebar-menu">
      <div class="logo position-absolute start-0 end-0 top-0 bg-black division-company-name">
          <img src="../../assets/branding/centrallize-mark-ui.jpg" alt="Símbolo da Centrallize" width="34" />
          <span class="company-name fw-bold ms-10 fs-16">Centrallize</span>
        <div class="bb-2"></div>
        <button
          class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
          @click="stateStoreInstance.onChange"
        >
          <i class="ph ph-x"></i>
        </button>
      </div>
      <ul
        class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
        id="sidebarNavAccordion"
      >

        <li v-if="canAccessPage('dashboard')" @click="stateStoreInstance.onChange" class="dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/dashboard" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isDashboardActive }">
              <i class="flaticon-pie-chart-1"></i>
              <span class="title">Dashboard</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('calendar')" @click="stateStoreInstance.onChange" class="dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/calendar" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isCalendarActive }">
              <i class="flaticon-calendar"></i>
              <span class="title">Calendário</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('attendants-day')" @click="stateStoreInstance.onChange" class="dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/attendants-day" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isScheduleActive }">
              <i class="flaticon-book"></i>
              <span class="title">Agendamentos</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('chat')" @click="stateStoreInstance.onChange" class="realtime sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
            <router-link to="/chat" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
              <div :class="{ active: isChatActive }">
                <i class="flaticon-chat"></i>
                <span class="title">Conversas</span>

                <span v-if="getPendingMessagesChat.length > 0" class="new-badge fw-medium d-inline-block">{{ getPendingMessagesChat.length }}</span>
              </div>
            </router-link>
        </li>

        <li v-if="canAccessPage('whatsapp-campaigns')" @click="stateStoreInstance.onChange" class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/whatsapp-campaigns" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"><div :class="{ active: $route.path === '/whatsapp-campaigns' }"><i class="ph ph-megaphone"></i><span class="title">Campanhas WhatsApp</span></div></router-link>
        </li>

        <li v-if="canAccessPage('clients')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/clients" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isClientsActive }">
              <i class="flaticon-people"></i>
              <span class="title">Clientes</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('performance')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/performance" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isPerformanceActive }">
              <i class="flaticon-bar-chart-2"></i>
              <span class="title">Performance</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('sales')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/sales" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isSalesActive }">
              <i class="flaticon-shopping-cart-2"></i>
              <span class="title">Vendas</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('products')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/products" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isProductsActive }">
              <i class="flaticon-3d-cube"></i>
              <span class="title">Produtos</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('financial-management')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/financial-management" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isFinancialManagementActive }">
              <i class="flaticon-money"></i>
              <span class="title">Financeiro</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('configurations')" @click="stateStoreInstance.onChange" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/configurations" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isConfigurationActive }">
              <i class="flaticon-setting"></i>
              <span class="title">Configurações</span>
            </div>
          </router-link>
        </li>

        <li v-if="canAccessPage('payment')" @click="stateStoreInstance.onChange" class="pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/payment" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isPaymentActive }">
              <i class="flaticon-credit-card"></i>
              <span class="title">Pagamentos</span>
            </div>
          </router-link>
        </li>

        <li @click="openSupportWhatsapp" class="pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <button type="button" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block support-menu-button">
            <div>
              <i class="ph ph-whatsapp-logo"></i>
              <span class="title">Suporte</span>
            </div>
          </button>
        </li>

      </ul>
    </div>
  </div>

  <div
    v-if="mobileVisibleItems.length > 0"
    class="mobile-bottom-menu"
    :class="{ 'more-open': mobileMoreOpen }"
  >
    <button
      v-if="mobileMoreOpen"
      class="mobile-more-backdrop"
      type="button"
      aria-label="Fechar menu"
      @click="closeMobileMore"
    ></button>

    <div v-if="mobileMoreOpen" id="mobile-more-menu" class="mobile-more-menu">
      <router-link
        v-for="item in mobileMoreItems"
        :key="item.key"
        :to="mobileMenuTarget(item)"
        class="mobile-more-link"
        :class="{ active: isMobileItemActive(item) }"
        @click="closeMobileMore"
      >
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </router-link>

      <button
        class="mobile-more-link mobile-more-action"
        type="button"
        @click="openSupportWhatsapp"
      >
        <i class="ph ph-whatsapp-logo"></i>
        <span>Suporte</span>
      </button>

      <button
        class="mobile-more-link mobile-more-action"
        type="button"
        @click="toggleDarkMode"
      >
        <i :class="isDarkMode ? 'flaticon-sun' : 'flaticon-moon'"></i>
        <span>{{ isDarkMode ? 'Modo claro' : 'Modo escuro' }}</span>
      </button>

      <button
        class="mobile-more-link mobile-more-action mobile-logout-action"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#verticallyCenteredModal"
        @click="closeMobileMore"
      >
        <i class="flaticon-logout"></i>
        <span>Deslogar</span>
      </button>
    </div>

    <nav
      class="mobile-bottom-nav"
      :style="{ gridTemplateColumns: `repeat(${mobileBottomItemCount}, minmax(0, 1fr))` }"
      aria-label="Menu principal mobile"
    >
      <router-link
        v-for="item in mobilePrimaryItems"
        :key="item.key"
        :to="mobileMenuTarget(item)"
        class="mobile-bottom-link"
        :class="{ active: isMobileItemActive(item) }"
        @click="closeMobileMore"
      >
        <span class="mobile-bottom-icon">
          <i :class="item.icon"></i>
          <span
            v-if="item.key === 'chat' && getPendingMessagesChat.length > 0"
            class="mobile-new-badge"
          >
            {{ getPendingMessagesChat.length }}
          </span>
        </span>
        <span class="mobile-bottom-label">{{ item.label }}</span>
      </router-link>

      <button
        class="mobile-bottom-link mobile-more-button"
        :class="{ active: mobileMoreOpen || isMoreItemActive }"
        type="button"
        :aria-expanded="mobileMoreOpen ? 'true' : 'false'"
        aria-controls="mobile-more-menu"
        @click="toggleMobileMore"
      >
        <span class="mobile-bottom-icon">
          <i class="flaticon-menu-3"></i>
        </span>
        <span class="mobile-bottom-label">Ver mais</span>
      </button>
    </nav>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import stateStore from "../../utils/store";
import { useRoute } from "vue-router";
import { mapGetters, mapActions } from 'vuex';
import Pusher from 'pusher-js';
import { canAccessPage as hasPageAccess } from "../../utils/accessControl";
import { setAndroidNavigationMenuVisible } from "../../utils/androidNavigationBar";

export default defineComponent({
  name: "MainSidebar",
  data() {
    return {
      pusher: null as Pusher | null,
      channel: null as any,
      currentChannelName: null as string | null,
      currentEventName: null as string | null,
      currentConfigurationId: null as number | null,
      mobileMoreOpen: false,
      isDarkMode: false,
      mobileMenuItems: [
        { key: "whatsapp-campaigns", label: "Campanhas", path: "/whatsapp-campaigns", icon: "ph ph-megaphone" },
        { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: "flaticon-pie-chart-1" },
        { key: "financial-management", label: "Financeiro", path: "/financial-management", icon: "flaticon-money" },
        { key: "attendants-day", label: "Agendamentos", path: "/attendants-day", icon: "flaticon-book" },
        { key: "chat", label: "Conversas", path: "/chat", icon: "flaticon-chat" },
        { key: "calendar", label: "Calendario", path: "/calendar", icon: "flaticon-calendar" },
        { key: "clients", label: "Clientes", path: "/clients", icon: "flaticon-people" },
        { key: "performance", label: "Performance", path: "/performance", icon: "flaticon-bar-chart-2" },
        { key: "sales", label: "Vendas", path: "/sales", icon: "flaticon-shopping-cart-2" },
        { key: "products", label: "Produtos", path: "/products", icon: "flaticon-3d-cube" },
        { key: "configurations", label: "Configuracoes", path: "/configurations", icon: "flaticon-setting" },
        { key: "payment", label: "Pagamentos", path: "/payment", icon: "flaticon-credit-card" },
      ],
    };
  },
  setup() {
    const stateStoreInstance = stateStore;
    const route = useRoute();    
    
    const isDashboardActive = computed(() => route.path === '/dashboard');
    const isCalendarActive = computed(() => route.path === '/calendar');
    const isScheduleActive = computed(() => route.path === '/attendants-day');
    const isRecordingsActive = computed(() => route.path === '/recordings');
    const isChatActive = computed(() => route.path === '/chat');
    const isDispatcherMessagesActive = computed(() => route.path === '/dispatcher');
    const isClientsActive = computed(() => route.path === '/clients');
    const isPerformanceActive = computed(() => route.path === '/performance');
    const isSalesActive = computed(() => route.path === '/sales');
    const isProductsActive = computed(() => route.path === '/products');
    const isFinancialManagementActive = computed(() => route.path === '/financial-management');
    const isConfigurationActive = computed(() => route.path === '/configurations');
    const isPaymentActive = computed(() => route.path === '/payment');
    const isDocumentationActive = computed(() => route.path === '/documentation');

    
    
    return {
      stateStoreInstance,
      isDashboardActive,
      isCalendarActive,
      isScheduleActive,
      isRecordingsActive,
      isChatActive,
      isDispatcherMessagesActive,
      isClientsActive,
      isSalesActive,
      isProductsActive,
      isFinancialManagementActive,
      isPerformanceActive,
      isConfigurationActive,
      isPaymentActive,
      isDocumentationActive,
      // pusher
    };
  },
  computed:{
    ...mapGetters([
      'getConfigurations',
      'getPendingMessagesChat',
      'getAllowedPages'
    ]),
    mobilePrimaryItems(): any[] {
      const primaryKeys = ["dashboard", "clients", "attendants-day", "chat"];
      const visibleItems = this.mobileRouteItems;
      const selectedItems: any[] = [];

      primaryKeys.forEach((key) => {
        const item = visibleItems.find((menuItem) => menuItem.key === key);
        if (item) {
          selectedItems.push(item);
        }
      });

      visibleItems.forEach((item) => {
        if (!selectedItems.some((selectedItem) => selectedItem.key === item.key)) {
          selectedItems.push(item);
        }
      });

      return selectedItems.slice(0, 4);
    },
    mobileMoreItems(): any[] {
      const primaryKeys = this.mobilePrimaryItems.map((item) => item.key);

      return this.mobileRouteItems.filter((item) => !primaryKeys.includes(item.key));
    },
    mobileRouteItems(): any[] {
      return (this.mobileMenuItems as any[]).filter((item) => this.canAccessPage(item.key));
    },
    mobileVisibleItems(): any[] {
      return [...this.mobilePrimaryItems, ...this.mobileMoreItems, { key: 'support' }];
    },
    mobileBottomItemCount(): number {
      return this.mobilePrimaryItems.length + 1;
    },
    isMoreItemActive(): boolean {
      return this.mobileMoreItems.some((item) => this.isMobileItemActive(item));
    }
  },
  methods:{
    syncAndroidNavigationBar() {
      setAndroidNavigationMenuVisible(
        this.mobileVisibleItems.length > 0 && window.matchMedia('(max-width: 767px)').matches
      );
    },
    ...mapActions([
      "receiveNewQrCodeWebsocket",
      "receiveMessageWebsocket",
      "fetchMetricsMonthBillingGraphic",
      "fetchCardsDashboardMonth",
      "fetchMetricsMonthScheduleCategoriesHour",
      "refreshFinancialManagement",
      "receiveCalendarByWebsocket"
    ]),
    canAccessPage(pageKey: string){
      return hasPageAccess(this.getAllowedPages, pageKey);
    },
    openSupportWhatsapp() {
      this.closeMobileMore();
      stateStore.onChange();
      window.open("https://wa.me/5511915100084", "_blank", "noopener,noreferrer");
    },
    mobileMenuTarget(item: any) {
      if (this.canAccessPage(item.key)) {
        return item.path;
      }

      return {
        path: "/access-denied",
        query: {
          module: item.label,
          key: item.key,
        },
      };
    },
    isMobileItemActive(item: any) {
      return this.$route.path === item.path || (
        this.$route.path === "/access-denied" && this.$route.query.key === item.key
      );
    },
    toggleMobileMore() {
      this.mobileMoreOpen = !this.mobileMoreOpen;
    },
    closeMobileMore() {
      this.mobileMoreOpen = false;
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      document.body.classList.toggle("dark", this.isDarkMode);
      localStorage.setItem("dark", this.isDarkMode.toString());
      this.closeMobileMore();
    },
    connectPusher(newValue: any){
      if (!newValue || !newValue.id) {
        return;
      }

      const channelName = 'logchat-' + newValue.id;
      const eventName = 'receiveMessage-' + newValue.id + newValue.id;

      if (
        this.pusher &&
        this.currentConfigurationId === newValue.id &&
        this.currentChannelName === channelName &&
        this.currentEventName === eventName
      ) {
        return;
      }

      if (!this.pusher) {
        this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
          cluster: process.env.VUE_APP_PUSHER_CLUSTER
        });
      }

      if (this.channel && this.currentEventName) {
        this.channel.unbind(this.currentEventName);
      }

      if (this.pusher && this.currentChannelName) {
        this.pusher.unsubscribe(this.currentChannelName);
      }
      const receiveMessageWebsocket = this.receiveMessageWebsocket;
      const receiveNewQrCodeWebsocket = this.receiveNewQrCodeWebsocket;
      const fetchMetricsMonthBillingGraphic = this.fetchMetricsMonthBillingGraphic;
      const fetchCardsDashboardMonth = this.fetchCardsDashboardMonth;
      const fetchMetricsMonthScheduleCategoriesHour = this.fetchMetricsMonthScheduleCategoriesHour;

      const receiveCalendarByWebsocket = this.receiveCalendarByWebsocket;

      const channel = this.pusher.subscribe(channelName);
      this.channel = channel;
      this.currentChannelName = channelName;
      this.currentEventName = eventName;
      this.currentConfigurationId = newValue.id;

      channel.bind(eventName, (data) => {

          if(data.type == 'WHATSAPP_DISCONNECTED'){

            receiveNewQrCodeWebsocket(data);

          } else if(data.type == 'WHATSAPP_CONNECTED'){

            receiveNewQrCodeWebsocket(data);

          } else if(data.type == 'NEW_QR_CODE'){

            receiveNewQrCodeWebsocket(data);

          } else if (data.type == 'NEW_MESSAGE'){
            receiveMessageWebsocket(data);
          } else if (data.type === 'CALENDAR_UPDATED') {
            receiveCalendarByWebsocket(data.calendar);
          }
          else {
            fetchMetricsMonthBillingGraphic();
            fetchCardsDashboardMonth();
            fetchMetricsMonthScheduleCategoriesHour();
            if (this.$route.path === '/financial-management') {
              this.refreshFinancialManagement();
            }

            if(data.type == 'NEW_SCHEDULED_METRICS' || data.type == 'NEW_CANCELED_METRICS'){
              // ATUALIZANDO CALENDÁRIO....
              receiveCalendarByWebsocket(data.calendar);
            }
          }

          // if(data.data && data.statusCode){
          //   if(data.statusCode == 200){
          //     setNewStatusAddSuccess(data.data)
          //   } else {
          //     setNewStatusAddError(data.data);
          //   }
          // }
      });
    }
  },
  watch:{
    mobileVisibleItems() {
      this.syncAndroidNavigationBar();
    },
    $route() {
      this.closeMobileMore();
    },
    getConfigurations: {
      immediate: true,
      handler(newValue: any){
        this.connectPusher(newValue);
      }
    }
  },
  mounted() {
    this.syncAndroidNavigationBar();
    window.addEventListener('resize', this.syncAndroidNavigationBar);
    const storedDarkMode = localStorage.getItem("dark");
    if (storedDarkMode) {
      this.isDarkMode = storedDarkMode === "true";
      document.body.classList.toggle("dark", this.isDarkMode);
    }
  },
  unmounted(){
    window.removeEventListener('resize', this.syncAndroidNavigationBar);
    setAndroidNavigationMenuVisible(false);
    if (this.channel && this.currentEventName) {
      this.channel.unbind(this.currentEventName);
    }
    if (this.pusher && this.currentChannelName) {
      this.pusher.unsubscribe(this.currentChannelName);
      this.pusher.disconnect();
    }
  }
});
</script>
<style scoped>
.active {
  color: #fff;
}

.company-name{
  font-size: 16pt;
  color: #fff;
}

.division-company-name img {
  border-radius: 8px;
}

.division-company-name{
  border-bottom: 1px solid #444 !important;
}

.new-badge {
  top: -1px;
  z-index: 1;
  padding: 0 5px;
  font-size: 11px;
  margin-left: 8px;
  position: relative;
  background: #6fd3f7;
  color: var(--splash-black-color);
}
.new-badge::before {
  top: 50%;
  width: 8px;
  height: 8px;
  content: "";
  z-index: -1;
  left: -2.5px;
  position: absolute;
  background: #6fd3f7;
  transform: translateY(-50%) rotate(45deg);
}

.support-menu-button {
  border: 0;
  color: var(--splash-body-color);
  padding: 0;
  text-align: left;
}

.support-menu-button:hover {
  color: #fff;
}

.mobile-bottom-menu {
  display: none;
}

@media (max-width: 767px) {
  .sidebar-area {
    display: none;
  }

  .mobile-bottom-menu {
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: block;
    position: fixed;
    background: #0d0c1d;
  }

  .mobile-bottom-nav {
    gap: 2px;
    display: grid;
    min-height: 70px;
    padding: 6px 8px max(8px, calc(6px + env(safe-area-inset-bottom)));
    position: relative;
    background: #0d0c1d;
    box-shadow: 0 -10px 30px rgba(13, 12, 29, 0.18);
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .mobile-bottom-link {
    gap: 3px;
    border: 0;
    display: flex;
    height: 56px;
    min-width: 0;
    color: #bcbbc7;
    line-height: 1;
    font-size: 11px;
    font-weight: 600;
    text-align: center;
    align-items: center;
    text-decoration: none;
    background: transparent;
    justify-content: center;
    flex-direction: column;
    border-radius: 8px;
    padding: 6px 3px 5px;
    transition: color 120ms ease, background-color 120ms ease, box-shadow 120ms ease;
  }

  .mobile-bottom-link:hover {
    color: #fff;
  }

  .mobile-bottom-link.active {
    color: #fff;
    background: rgba(105, 101, 245, 0.28);
    box-shadow: inset 0 0 0 1px rgba(105, 101, 245, 0.4);
  }

  .mobile-bottom-link.active .mobile-bottom-icon {
    color: #fff;
  }

  .mobile-bottom-icon {
    width: 24px;
    height: 24px;
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
  }

  .mobile-bottom-icon i {
    font-size: 21px;
    line-height: 1;
  }

  .mobile-bottom-label {
    width: 100%;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .mobile-more-backdrop {
    inset: auto 0 0;
    border: 0;
    width: 100%;
    height: 100vh;
    position: fixed;
    background: rgba(13, 12, 29, 0.18);
  }

  .mobile-more-menu {
    left: 15px;
    right: 15px;
    bottom: max(76px, calc(64px + env(safe-area-inset-bottom)));
    z-index: 1;
    display: grid;
    overflow: hidden;
    position: absolute;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 18px 45px rgba(13, 12, 29, 0.22);
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .mobile-more-link {
    gap: 10px;
    min-width: 0;
    display: flex;
    color: #5b5a68;
    font-size: 13px;
    font-weight: 600;
    align-items: center;
    text-decoration: none;
    padding: 14px 16px;
    border-bottom: 1px solid #f0eef7;
  }

  .mobile-more-action {
    border: 0;
    width: 100%;
    background: #fff;
    text-align: left;
  }

  .mobile-logout-action,
  .mobile-logout-action i {
    color: #dc3545;
  }

  .mobile-more-link:nth-child(odd) {
    border-right: 1px solid #f0eef7;
  }

  .mobile-more-link i {
    color: var(--splash-primary-color);
    font-size: 18px;
    line-height: 1;
  }

  .mobile-more-link span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .mobile-more-link.active {
    color: var(--splash-primary-color);
    background: #f5f4ff;
  }

  .mobile-new-badge {
    top: -5px;
    right: -8px;
    min-width: 16px;
    height: 16px;
    color: #0d0c1d;
    display: inline-flex;
    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    position: absolute;
    align-items: center;
    border-radius: 999px;
    justify-content: center;
    background: #6fd3f7;
    padding: 0 4px;
  }
}

@media (min-width: 1200px) {
  .sidebar-area.attendants-day-sidebar {
    width: 64px;
  }

  .sidebar-area.attendants-day-sidebar .logo {
    margin-right: 0;
    padding-left: 15px;
    padding-right: 15px;
  }

  .sidebar-area.attendants-day-sidebar .company-name,
  .sidebar-area.attendants-day-sidebar .sidebar-burger-menu,
  .sidebar-area.attendants-day-sidebar .sidebar-navbar-nav .title,
  .sidebar-area.attendants-day-sidebar .sidebar-navbar-nav .accordion-button::after {
    display: none !important;
  }

  .sidebar-area.attendants-day-sidebar .sidebar-menu {
    overflow-y: hidden;
    padding-left: 0;
    padding-right: 0;
    padding-top: 120px;
  }

  .sidebar-area.attendants-day-sidebar .sidebar-navbar-nav {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .sidebar-area.attendants-day-sidebar .sidebar-navbar-nav .sidebar-nav-item {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    width: 100%;
  }

  .sidebar-area.attendants-day-sidebar .sidebar-menu .sidebar-navbar-nav .sidebar-nav-item .accordion-button,
  .sidebar-area.attendants-day-sidebar .sidebar-menu .sidebar-navbar-nav .sidebar-nav-item .support-menu-button {
    align-items: center;
    display: flex !important;
    height: 32px !important;
    justify-content: center;
    padding: 0 !important;
    text-align: center;
    width: 100% !important;
  }

  .sidebar-area.attendants-day-sidebar .sidebar-menu .sidebar-navbar-nav .sidebar-nav-item .accordion-button > div,
  .sidebar-area.attendants-day-sidebar .sidebar-menu .sidebar-navbar-nav .sidebar-nav-item .support-menu-button > div {
    align-items: center;
    display: flex !important;
    flex: 0 0 32px;
    height: 32px !important;
    justify-content: center;
    position: relative;
    width: 32px !important;
  }

  .sidebar-area.attendants-day-sidebar .sidebar-menu .sidebar-navbar-nav .sidebar-nav-item .accordion-button i,
  .sidebar-area.attendants-day-sidebar .sidebar-menu .sidebar-navbar-nav .sidebar-nav-item .support-menu-button i {
    left: 50% !important;
    right: auto;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
  }

  .sidebar-area.attendants-day-sidebar .new-badge {
    border-radius: 999px;
    font-size: 9px;
    line-height: 14px;
    margin-left: 0;
    min-width: 14px;
    padding: 0 4px;
    position: absolute;
    right: -9px;
    top: -9px;
  }

  .sidebar-area.attendants-day-sidebar .new-badge::before {
    display: none;
  }
}
</style>
